import { uniqBy } from 'lodash';
import { UserType } from 'api/models';
import { currentUserState } from './current-user-state';
export const isCurrentUserTypeExternal = ()=>{
    var _currentUserState_userState;
    return ((_currentUserState_userState = currentUserState.userState) === null || _currentUserState_userState === void 0 ? void 0 : _currentUserState_userState.currentUser.user.userType) === UserType.External;
};
export const isNonStrategicCompany = (company)=>company.strategic === false;
const updateCompanyIfNonStrategic = (company)=>{
    var _currentUserState_userState;
    const vendorCompany = (_currentUserState_userState = currentUserState.userState) === null || _currentUserState_userState === void 0 ? void 0 : _currentUserState_userState.vendorCompany;
    return vendorCompany != null && isNonStrategicCompany(company) ? vendorCompany : company;
};
export const updateTaskAssigneeAndResponsibleCompany = (task)=>{
    try {
        var _task_assignee;
        return isCurrentUserTypeExternal() ? {
            ...task,
            assignee: task.assignee && {
                users: task.assignee.users.map((user)=>({
                        ...user,
                        company: updateCompanyIfNonStrategic(user.company)
                    })),
                teams: (_task_assignee = task.assignee) === null || _task_assignee === void 0 ? void 0 : _task_assignee.teams
            },
            responsible: uniqBy(task.responsible.map((company)=>updateCompanyIfNonStrategic(company)), 'companyId')
        } : task;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return task;
    }
};
export const updateTasksAssigneeAndResponsibleCompany = (tasks)=>{
    try {
        return isCurrentUserTypeExternal() ? tasks.map(updateTaskAssigneeAndResponsibleCompany) : tasks;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return tasks;
    }
};
const updateProjectPartners = (project)=>{
    try {
        var _project_partners;
        return isCurrentUserTypeExternal() ? {
            ...project,
            partners: ((_project_partners = project.partners) !== null && _project_partners !== void 0 ? _project_partners : []).filter((x)=>isNonStrategicCompany(x))
        } : project;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return project;
    }
};
export const updateProjectsPartners = (projects)=>{
    try {
        return isCurrentUserTypeExternal() ? projects.map(updateProjectPartners) : projects;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return projects;
    }
};
